import request from 'superagent';
import * as fakeApi from './fake-api';
import { API_BASE_URL, NEW_API_BASE_URL } from 'Common/constants';
import { delay } from 'Common/utils';

export function fetchJuridicalList() {
  const url = `${NEW_API_BASE_URL}/enums/get-juridical-list`;
  const req = request.get(url);
  return req;
}

export function fetchRegions() {
  const url = `${NEW_API_BASE_URL}/enums/get-regions`;
  const req = request.get(url);
  return req;
}

export function fetchDistricts(regionId) {
  const url = `${NEW_API_BASE_URL}/enums/get-districts`;
  const req = request.get(url).query({ region_id: regionId });
  return req;
}

export function fetchMakhallas(regionId, districtId) {
  const url = `${NEW_API_BASE_URL}/enums/get-mahalla`;
  const req = request.get(url).query({ region_id: regionId, district_id: districtId });
  return req;
}

export function fetchCountries() {
  const url = `${NEW_API_BASE_URL}/enums/countries`;
  const req = request.get(url);
  return req;
}

export function fetchInvalidList() {
  const url = `${NEW_API_BASE_URL}/enums/get-invalid-list`;
  const req = request.get(url);
  return req;
}

export function fetchGuid() {
  const url = `${NEW_API_BASE_URL}/utils/guid`;
  const req = request.get(url);
  return req;
}

export const fetchPhonePattern = (id) => {
  const url = `${NEW_API_BASE_URL}/sms/country-phone-pattern`;
  const req = request.get(url).query({ id });
  return req;
};

export const fetchCaptcha = () => {
  const url = `${API_BASE_URL}/site/captcha?refresh=1`;
  const req = request.get(url);
  return req;
};

export function sendUserData(data) {
  let url = '';
  if (data.document_type === 'passport') {
    url = `${NEW_API_BASE_URL}/gsp/person-data`;
  } else {
    url = `${NEW_API_BASE_URL}/mip-birth/find-by-doc`;
  }
  const req = request.post(url).type('form').send(data);
  return req;
}

export const sendFeedback = (data) => {
  const url = `${NEW_API_BASE_URL}/feedback/create`;
  const req = request.post(url).type('application/json').send(data);
  return req;
};

export function sendCode(data) {
  const url = `${NEW_API_BASE_URL}/sms/send-code`;
  const req = request.post(url).type('form').send(data);
  return req;
}

export function checkCode(data) {
  const url = `${NEW_API_BASE_URL}/sms/check-code`;
  const req = request.post(url).type('form').send(data);
  return req;
}

export function fetchSendDraft(formData, id) {
  const customData = {
    ...formData,
    is_agree_electronically:
      formData.is_agree_electronically === 'true' || formData.is_agree_electronically === true ? true : false,
  };
  const url = `${NEW_API_BASE_URL}/draft-request/send-draft`;
  const req = request.post(url).query({ id }).send(customData);
  return req;
}

export function fetchGetDraft(queryParams) {
  const url = `${NEW_API_BASE_URL}/draft-request/get-draft`;
  const req = request.get(url).query(queryParams);
  return req;
}

export function fecthGetUserFiles(queryParams) {
  const url = `${NEW_API_BASE_URL}/draft-request/get-uploaded-files`;
  const req = request.get(url).query(queryParams);
  return req;
}

export function uploadFile(data, errorCb) {
  const url = `${API_BASE_URL}/file/file/upload`;
  const req = request.post(url).send(data).on('error', errorCb);
  return req;
}

export function deleteUploadedFile(data) {
  const url = `${NEW_API_BASE_URL}/draft-request/remove-link-draft-files`;
  console.log(data);
  const req = request.post(url).send(data);
  return req;
}

export const fetchStatus = () => {
  return delay(100).then(() => {
    if (window.LANG && window.LANG === 'uz')
      return [
        { id: 1, value: 'Ишлайди' },
        { id: 2, value: 'Ишсиз' },
        { id: 3, value: 'Пенсионер' },
        { id: 4, value: 'Талаба' },
        { id: 0, value: '-' },
      ];
    else if (window.LANG && window.LANG === 'ru')
      return [
        { id: 1, value: 'Работает' },
        { id: 2, value: 'Безработный' },
        { id: 3, value: 'Пенсионер' },
        { id: 4, value: 'Студент' },
        { id: 0, value: '-' },
      ];
    return [
      { id: 1, value: 'Ishlaydi' },
      { id: 2, value: 'Ishsiz' },
      { id: 3, value: 'Pensioner' },
      { id: 4, value: 'Talaba' },
      { id: 0, value: '-' },
    ];
  });
};

export const sendTin = (data) => {
  const url = `${NEW_API_BASE_URL}/mib/get-organization-data`;
  const req = request.post(url).send(data);
  return req;
};

export const getApi = () => {
  if (process.env.NODE_ENV === 'production') {
    return {
      fetchStatus,
      fetchRegions,
      fetchDistricts,
      fetchMakhallas,
      sendCode,
      checkCode,
      uploadFile,
      fetchCountries,
      fetchPhonePattern,
      fetchGuid,
      deleteUploadedFile,
      fetchJuridicalList,
      sendUserData,
      fetchCaptcha,
      sendFeedback,
      fetchSendDraft,
      fetchGetDraft,
      fecthGetUserFiles,
      sendTin,
      fetchInvalidList,
    };
  } else {
    return fakeApi;
  }
};

export const Api = getApi();

export default getApi;



// WEBPACK FOOTER //
// ./src/application-form/api.js